import { render, staticRenderFns } from "./JobCardRoomType.vue?vue&type=template&id=e1c87a02&scoped=true&"
import script from "./JobCardRoomType.vue?vue&type=script&lang=js&"
export * from "./JobCardRoomType.vue?vue&type=script&lang=js&"
import style0 from "./JobCardRoomType.vue?vue&type=style&index=0&id=e1c87a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c87a02",
  null
  
)

export default component.exports